import { isDefined, isEmptyString } from 'lib/typeInference';
import React from 'react';

export function useDeliveryNote(defaultNote?: string): [string | undefined, (note?: string) => void] {
    const [note, setNote] = React.useState(defaultNote);
    const handleNoteChange = React.useCallback((note?: string) => {
        setNote(note);
    }, []);
    React.useEffect(() => {
        if (!isDefined(note) && isDefined(defaultNote) && !isEmptyString(defaultNote)) {
            setNote(defaultNote);
        }
    }, [defaultNote, note]);
    return [note, handleNoteChange];
}
